export default __webpack_public_path__ + "static/media/heater.d518165e.svg";